/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
// Models
import { ApiResponse, GlobalPriceConfigurationPriceType } from '@core/models';
// Rxjs
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Services
import { ApiService } from 'app/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalPriceConfigurationPriceTypeService {
  activePageIndex: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  constructor(private http: HttpClient, private apiService: ApiService) {}

  updateGlobalPriceConfigurationPriceType(
    priceType: Partial<GlobalPriceConfigurationPriceType>,
    updatedBy: string
  ): Observable<ApiResponse<GlobalPriceConfigurationPriceType>> {
    return this.http
      .put<ApiResponse<GlobalPriceConfigurationPriceType>>(
        `${this.apiService.superAdminApi}/global-price-configuration-price-type`,
        { priceType, updatedBy }
      )
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  batchUpdateGlobalPriceConfigurationPriceType(
    priceTypes: Partial<GlobalPriceConfigurationPriceType[]>,
    updatedBy: string
  ): Observable<ApiResponse<GlobalPriceConfigurationPriceType[]>> {
    return this.http
      .put<ApiResponse<GlobalPriceConfigurationPriceType[]>>(
        `${this.apiService.superAdminApi}/global-price-configuration-price-type/batch`,
        { priceTypes, updatedBy }
      )
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }
}
